import { AxiosHelper } from "../axiosConfig";
import { ISlide } from "../model/interface/slide";
import APIConstant from "../utils/apiConstant";

export const getSlides = (
  slide: ISlide,
  pageSize: number,
  pageNumber: number,
  orderbyColumn: string,
  sortDir: string
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SLIDES, {
    params: {
      pageSize: pageSize,
      pageNumber: pageNumber,
      standardId: slide.standardId,
      title: slide.title,
      description: slide.description,
      isActive: slide.isActive,
      orderbyColumn: orderbyColumn,
      sortDir: sortDir,
      slideId: slide.slideId,
      link: slide.link,
      standardName: slide.standardName,
      gradeLevel: slide.gradeLevel,
      contentAreaId: slide.contentAreaId,
    },
  });
};

export const getSlide = (id: number) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_SLIDE, {
    params: { id: id },
  });
};

export const getStandardSlides = (
  standardId: number,
  pageNumber: number,
  pageSize: number
) => {
  return AxiosHelper.axiosInstance().get(APIConstant.CMS_STANDARD_SLIDES, {
    params: {
      standardId: standardId,
      pageNumber: pageNumber,
      pageSize: pageSize,
    },
  });
};

export const saveSlide = (slide: ISlide) => {
  return AxiosHelper.axiosInstance().post(APIConstant.CMS_SLIDES, slide);
};

export const deleteSlide = (slideId: number) => {
  return AxiosHelper.axiosInstance().delete(APIConstant.CMS_SLIDES, {
    params: { id: slideId },
  });
};

export const associateStandardSlides = (
  standardId: number,
  slideIds: number[]
) => {
  return AxiosHelper.axiosInstance().post(
    APIConstant.CMS_ASSOCIATE_STANDARD_SLIDES,
    {
      standardId,
      slideIds,
    }
  );
};

export const unassociateSlideStandards = (
  slideId: number,
  standardIds: number[]
) => {
  return AxiosHelper.axiosInstance().delete(
    APIConstant.CMS_SLIDE_UNASSOCIATE_STANDARDS,
    {
      data: {
        slideId,
        standardIds,
      },
    }
  );
};
